
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthProvider";
import { API_URL } from "../utils/config";
const baseUrl = API_URL;

export const useSuppliers = () => {
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();
    const [suppliers, setSuppliers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);



    
  const getLangFromLocalStorage = () => {
    return localStorage.getItem("language") || "en";
  };

    const fetchSuppliers = async () => {
        try {
            if (!isAuthenticated) return;
            const response = await fetch(`${baseUrl}/api/v1/attnd-supplier/suppliers/assignedSuppliers`, {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    lang: getLangFromLocalStorage(),

                },
            });

            if (!response.ok) {
                if (response.status === 401) throw new Error("Unauthorized");
                throw new Error("Failed to fetch suppliers");
            }

            const { data } = await response.json();
            setSuppliers(data);
        } catch (err) {
            console.error("Error fetching suppliers:", err);
            if (err.message === "Unauthorized") navigate("/login");
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSuppliers();
    }, []);

    return { suppliers, loading, error };
};